import { render, staticRenderFns } from "./SettingListCard.vue?vue&type=template&id=44e1ed08&scoped=true"
import script from "./SettingListCard.vue?vue&type=script&lang=js"
export * from "./SettingListCard.vue?vue&type=script&lang=js"
import style0 from "./SettingListCard.vue?vue&type=style&index=0&id=44e1ed08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e1ed08",
  null
  
)

export default component.exports